<template>
  <router-link class="text-decoration-none" :to="pageRoute">
    <div  class="mt-8 w-80 mx-auto d-flex justify-start align-center">
      <div
      
          :class="checkPageRoute()"
          class="skew px-2  py-4"></div>
      <h2 :class="[this.pageRoute.indexOf('material')>0?color+'--text':'','font-weight-bold pr-3']">{{title}}</h2>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "AboutTitle",
  props:{
    title:String,
    pageRoute:String,
    color:String,
  },
  methods:{
    checkPageRoute(){
      if (this.$route.path.indexOf('light-blocks')>0){
        return 'success'
      }
      else if (this.$route.path.indexOf('material')>0){
        return this.color
      }else{
        return 'primary'
        }
    }
  }
}
</script>
